import React from "react";

const ReportsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        id="db36"
        d="M19.623,2.377A1.3,1.3,0,0,0,18.711,2H3.288a1.316,1.316,0,0,0-.911.377A1.294,1.294,0,0,0,2,3.288V5.859H17.429V7.147H2V18.712A1.271,1.271,0,0,0,3.288,20H18.711a1.294,1.294,0,0,0,.906-.371A1.316,1.316,0,0,0,20,18.712V3.288a1.3,1.3,0,0,0-.377-.911ZM3.929,4.571a.644.644,0,1,1,.644-.644A.644.644,0,0,1,3.929,4.571Zm1.929,0A.644.644,0,1,1,6.5,3.927.644.644,0,0,1,5.859,4.571Zm.411,6a.652.652,0,0,1,.917-.045l1.631,1.479,2.334-2.694.973.827L9.363,13.351a.647.647,0,0,1-.917.051L6.815,11.917l-2.4,2.728-.973-.832Zm11.16,6.857H3.929V16.141h13.5Zm0-3.212H13.57V12.929h3.859Zm0-3.212H13.57V9.712h3.859Z"
        transform="translate(-2 -2)"
        fill={fill ? fill : "#f7428f"}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ReportsIcon;
